import React from "react";

import {
  FaExchangeAlt,
  FaHandHoldingUsd,
  FaCoins,
  FaChartPie,
  FaWallet,
  FaFileContract,
  FaDice,
  FaTractor,
  FaRocket,
  FaChartLine,
  FaWater,
  FaShieldAlt,
} from "react-icons/fa";

function OurDeFiServices() {
  const services = [
    {
      title: "Decentralized Exchange (DEX) Development",
      desc: "We develop robust DEX platforms that allow users to trade assets directly, eliminating intermediaries and reducing transaction costs while maintaining the highest security standards.",
      icon: <FaExchangeAlt />,
    },
    {
      title: "DeFi Lending & Borrowing Platforms",
      desc: "Build peer-to-peer lending and borrowing platforms where users can securely lend their assets or access decentralized loans, leveraging collateralized cryptocurrencies.",
      icon: <FaHandHoldingUsd />,
    },
    {
      title: "Yield Farming & Staking Platforms",
      desc: "Enable users to maximize their returns by offering secure yield farming and staking platforms. Our smart contract-based solutions ensure automated rewards and transparent operations.",
      icon: <FaChartLine />,
    },
    {
      title: "Liquidity Pool & AMM Development",
      desc: "Create automated market-making (AMM) platforms and liquidity pools that facilitate smooth and efficient trading, ensuring liquidity providers earn incentives while improving market depth.",
      icon: <FaWater />,
    },
    {
      title: "DeFi Wallet Development",
      desc: "We build secure, non-custodial wallets that allow users to manage their DeFi assets, interact with decentralized applications (dApps), and participate in various DeFi protocols seamlessly.",
      icon: <FaWallet />,
    },
    {
      title: "Smart Contract Development & Auditing",
      desc: "Xeer Technology ensures the development of secure, transparent, and self-executing smart contracts, and we provide rigorous smart contract auditing services to eliminate vulnerabilities.",
      icon: <FaFileContract />,
    },
    {
      title: "Liquidity",
      desc: "DeFi promotes financial inclusion by enabling access to financial services to the underbanked or unbanked population.",
      icon: <FaCoins />,
    },
    {
      title: "Innovation Enablement",
      desc: "DeFi’s open, permissionless, and programmable architecture enables the creation of financial services and instruments that meet users’ needs.",
      icon: <FaRocket />,
    },
    {
      title: "Enhanced Security",
      desc: "Blockchain architecture ensures tamper proof, secure and auditable data while bringing users on the safer side.",
      icon: <FaShieldAlt />,
    },
  ];

  return (
    <section className="defi-section">
      <div className="container">
        {/* HEADER */}
        <div className="defi-header">
          <h4 className="defi-subtitle">Our Capabilities</h4>
          <h2 className="defi-title">Our DeFi Development Services</h2>
          <p className="defi-desc">
            We bridge traditional liquidity into decentralized ecosystems using
            powerful blockchain protocols.
          </p>
        </div>

        {/* GRID */}
        <div className="defi-grid">
          {services.map((service, index) => (
            <div className="defi-card" key={index}>
              <div className="card-glow"></div>

              <div className="defi-icon">{service.icon}</div>

              <h5 className="defi-card-title">{service.title}</h5>
              <p className="defi-card-desc">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurDeFiServices;
